export const COMMISSION_CONTRIBUTOR_ROLES = {
    relationship_owner: 'Relationship Owner',
    lead_generator: 'Lead Generator',
    sales_executive: 'Sales Executive',
    solution_consultant: 'Solution Consultant',
    referral_partner: 'Referral Partner',
    strategic_partner: 'Strategic Partner'
};

export const COMMISSION_CONTRIBUTOR_ROLE_ORDER = Object.keys(COMMISSION_CONTRIBUTOR_ROLES);

export function getCommissionContributorRoleLabel(key) {
    return COMMISSION_CONTRIBUTOR_ROLES[key] || key;
}
